export const WEDDING_REFUND_STATUS = {
  '0': '-',
  '1': '退款中',
  '2': '退款成功',
  '3': '退款失败',
  '4': '买家申请退款',
  '5': '买家申请退货',
  '6': '商家拒绝退款',
  '7': '商家拒绝退货',
  '8': '等待买家退货',
  '9': '等待商家收货',
  '10': '商家未收到货',
  '11': '退款完成',
  '12': '退款取消',
  '13': '退款关闭',
  null: '-'
}

export const WEDDING_ORDER_STATUS = {
  '10': '等待买家付款',
  '87': '已付款',
  '88': '等待商家发货',
  '89': '已发货，等待买家确认',
  '90': '交易完成',
  '91': '交易关闭',
  '92': '已评论',
  '93': '交易关闭'
}
